import React from "react";

export const OnHandAmounts = () => {
  return <div>Edit on hand amounts help modal</div>;
};

export default OnHandAmounts;
